import React from 'react'
import styles from './ViewCoupon.module.css';
import moment from 'moment';

import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button' 
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton'
import Switch from '@material-ui/core/Switch'
import TextField from '@material-ui/core/TextField'

import EditRoundedIcon from '@material-ui/icons/EditRounded';
import AddRoundedIcon from '@material-ui/icons/AddRounded';
import FilterListRoundedIcon from '@material-ui/icons/FilterListRounded';
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded';
import CheckCircleOutlineRoundedIcon from '@material-ui/icons/CheckCircleOutlineRounded';
import HighlightOffRoundedIcon from '@material-ui/icons/HighlightOffRounded';

import TableComp from '../../utils/Table/Table';
import AppLoader from '../../utils/AppLoader/AppLoader';

import {connect} from 'react-redux'
import {getAllCoupon,onCouponDelete} from '../../../containers/coupon/actions'
import {withRouter} from 'react-router-dom'
import ConfirmAlert from '../../utils/ConfirmAlert/ConfirmAlert';


const ViewCoupon = (props) => { 
    const [coupon,setCoupon] = React.useState(props.coupon);
    const [showEntries,setShowEntries] = React.useState(10)
    const [searchVal,setSearchVal] = React.useState("");

    React.useEffect(() => {
        if(!props.coupon) {
            props.getAllCoupon();
        }
        setCoupon(props.coupon);
    },[props.coupon]);

    let isLoading = !coupon;
    let showData = !isLoading;
    let rowData = [];

    !isLoading && coupon.forEach((coupon,index) => {
        if(index+1 <= showEntries || showEntries == "All") {
            if(coupon.code.substring(0,10).toLowerCase().includes(searchVal.toLowerCase()) ){
                rowData.push([
                    index + 1,
                    coupon.code, 
                    coupon.amount,
                    coupon.expireDate && moment(coupon.expireDate).format('DD/MM/YYYY'),
    
                    coupon.isActive
                        ?
                    <CheckCircleOutlineRoundedIcon style={{color: "green"}} />
                        :
                    <HighlightOffRoundedIcon style={{color: "red"}}/>,
                    
                    <React.Fragment>
                        <Tooltip title="Edit Coupon">
                            <IconButton onClick={() => props.history.push("/admin/coupon/EDIT-COUPON?couponId="+ coupon._id )}>
                                <EditRoundedIcon />
                            </IconButton>
                        </Tooltip>
    
                        <ConfirmAlert msg={`Are you sure you want delete ${coupon.code}`} onClickEvent={() => props.onCouponDelete(coupon._id)}>
                            <Tooltip title="Delete Coupon">
                                <IconButton>
                                    <DeleteRoundedIcon />
                                </IconButton>
                            </Tooltip>
                        </ConfirmAlert>
                    </React.Fragment>
                ])
            }
        }
    });
 
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.leftHeader}>
                    <p>Show Entries</p>
                    <Select value={showEntries} onChange={e => setShowEntries(e.target.value)}>
                        <MenuItem value={10}>10</MenuItem>
                        <MenuItem value={20}>20</MenuItem>
                        <MenuItem value={30}>30</MenuItem>
                        <MenuItem value={30}>50</MenuItem>
                        <MenuItem value={"All"}>All</MenuItem>
                    </Select>
                </div>

                <div className={styles.rightHeader}>
                    <TextField
                        label="Search Here"
                        className={styles.search}
                        value={searchVal}
                        onChange={e => setSearchVal(e.target.value)}
                    />
                    <Button color="primary" variant="contained" endIcon={<AddRoundedIcon />} onClick={() => props.history.push("/admin/coupon/ADD-COUPON")}>Add Coupon</Button>
                </div>
            </div>

            {isLoading && <AppLoader />}

            {showData &&
            <TableComp 
                columns={["Sl No","Coupon Code","Amount","Expiry Date","Active","Action"]}
                rows={rowData}
            />}

        </div>
    )
}
const mapStateToProps = state => ({
    coupon: state.coupon.coupon
})
export default withRouter(connect(mapStateToProps,{getAllCoupon,onCouponDelete})(ViewCoupon));